import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import { ButtonBase, FormControl } from '@mui/material';
import { Box } from '@mui/system';
import errorImage from '../../Assets/Images/error.svg';
import './text-field.css';

export const TextField = (props) => {
	const {
		text = '',
		textcolor = '#8E8E8E',
		type,
		imageleft,
		imageRight,
		greentick,
		removeImageLeftBorder,
		borderColor,
		textLeft,
		handleRightButton,
		handleInput,
		name,
		error,
		value,
		placeholder,
		width,
		height = '40px',
		greentickWidth,
		className,
		required,
		handleClick,
		disabled = false,
		labelClassName,
		handleMouseDown,
		handleMouseUp,
		handleMouseLeave,
		textArea,
		maxLength,
		autoComplete,
		textAreaPadding = 12,
		onCopy,
		onPaste,
		onBlur,
		onFocus,
		customStyle,
		marginTextBottom,
		textAreaHeight = '100%',
		errorRecep,
		marginTextTop,
		isColorChange = false,
		placeholderStyles = true,
		textMarginLeft,
		textMarginRight,
		newType = '',
		divStyles = {},
		maxDate = '',
		showBorder = false,
		leftBorder = false
	} = props;
	const [inputValue, setInputValue] = useState('');

	useEffect(() => {
		if (value !== inputValue) {
			setInputValue(value);
		}
	}, [value]);

	const handleInputChange = (e) => {
		const textValue = handleInput(
			type === 'checkbox' ? e.target.checked : e.target.value,
			e.target.name
		);
		if (textValue || textValue === '') {
			setInputValue(textValue);
		} else {
			if (newType === 'number') {
				const value = e.target.value;
				const cleanedValue = value.replaceAll(/\D/g, '');
				setInputValue(cleanedValue);
			}

			if (newType === 'astrick') {
				const value = e.target.value;
				const cleanedValue = value.replaceAll('*', ''); // Remove all asterisks
				setInputValue(cleanedValue);
			}
		}
	};

	const getAlignItemforTextArea = () => {
		if (textArea) {
			return 'flex-start';
		}

		return 'center';
	};

	const getLeftBorder = () => {
		if (leftBorder) {
			return '1px solid #b9b9b9';
		}

		return 'none';
	};

	const getBorder = () => {
		if (showBorder) {
			return '1px solid #b9b9b9';
		}

		return '1px solid #ECF0E5';
	};

	const getBackgroundColor = () => {
		if (greentick) {
			return { backgroundColor: '#b6d423' };
		}

		return { backgroundColor: null };
	};

	const getColorOfTextArea = () => {
		if (isColorChange) {
			return '#000000';
		}

		return '#8e8e8e';
	};

	const getErrorColor = () => {
		if (error) {
			return '#E96666';
		}

		if (disabled) {
			return getColorOfTextArea();
		}

		return '#000000';
	};

	const getPlaceholderStyles = () => {
		if (placeholderStyles) {
			return 'medium6 custom-placeholder';
		}

		return 'medium6';
	};

	const getPlaceholder = () => {
		if (placeholder) {
			return placeholder;
		}

		if (text) {
			return text;
		}

		return '';
	};

	return (
		<div style={divStyles}>
			{text && (
				<div
					className={labelClassName}
					style={{
						marginTop: marginTextTop || 0,
						marginBottom: marginTextBottom || 2,
						color: textcolor,
						backgroundColor: 'white'
					}}
				>
					{text}
				</div>
			)}

			<Stack
				direction='row'
				className={className}
				sx={{
					position: 'relative',
					width,
					height: textArea ? 'auto' : height,
					alignItems: getAlignItemforTextArea(),
					borderRadius: '8px',
					...(greentick && !error
						? {
							borderRight: getBorder(),
							borderTop: getBorder(),
							borderBottom: getBorder(),
							borderLeft: getLeftBorder()
						}
						: {
							...(error
								? { border: '1px solid #E96666' }
								: {
									border: `1px solid ${borderColor || '#8e8e8e'}`
								})
						})
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						height,
						borderTopLeftRadius: 6,
						borderBottomLeftRadius: 6,
						...getBackgroundColor()
					}}
				>
					{imageleft && (
						<img
							style={{
								height: 24,
								margin: 12,
								width: 24
							}}
							alt='textfieldImage'
							src={imageleft}
						/>
					)}
					{textLeft && (
						<div
							className='medium6'
							style={{
								// Margin: 12,
								width: greentickWidth,
								color: '#21241E',
								textAlign: 'center',
								marginLeft: textMarginLeft,
								marginRight: textMarginRight
							}}
						>
							{textLeft}
						</div>
					)}

					{!removeImageLeftBorder && (
						<div
							style={{
								borderRight: '2px solid #8e8e8e',
								height: 24,
								marginLeft: 2
							}}
						/>
					)}
				</div>
				<div style={{ display: 'flex', flex: 1 }}>
					<div style={{ width: '100%' }}>
						<FormControl sx={{ width: '100%' }}>
							{textArea && (
								<textarea
									className='medium6'
									rows='4'
									type={type}
									value={inputValue}
									name={name}
									required={Boolean(required)}
									onChange={handleInputChange}
									style={{
										alignItems: 'flex-start !important',
										borderWidth: 0,
										marginLeft: 2,
										backgroundColor: 'transparent',
										outlineWidth: 0,
										outline: 'none',
										padding: textAreaPadding,
										width: '100%',
										color: getErrorColor(),
										resize: 'none',
										height: textAreaHeight
									}}
									placeholder={getPlaceholder()}
									disabled={disabled}
									maxLength={maxLength}
								/>
							)}

							{!textArea && (
								<input
									onClick={handleClick}
									className={getPlaceholderStyles()}
									type={type}
									value={inputValue}
									name={name}
									required={Boolean(required)}
									onChange={handleInputChange}
									style={{
										borderWidth: 0,
										height: 28,
										marginLeft: 2,
										backgroundColor: 'transparent',
										outlineWidth: 0,
										padding: 8,
										width: '100%',
										color: getErrorColor(),
										cursor: disabled ? 'not-allowed' : 'auto',
										outline: 'none',
										...customStyle
									}}
									maxLength={maxLength}
									placeholder={getPlaceholder()}
									disabled={disabled}
									autoComplete={autoComplete}
									onBlur={(e) => onBlur?.(e)}
									onFocus={() => onFocus?.()}
									onCopy={(e) => onCopy?.(e)}
									onPaste={(e) => onPaste?.(e)}
									max={type === 'date' && maxDate ? maxDate : undefined}
								/>
							)}
						</FormControl>

						{error && (
							<div
								className='medium8'
								style={{
									color: '#E96666',
									position: 'absolute',
									bottom: -16,
									left: 0
								}}
							>
								{error}
							</div>
						)}
					</div>

					{imageRight && text.includes('Password') ? (
						<ButtonBase
							style={{
								color: '#000',
								width: 24,
								height: 24,
								borderRadius: 12,
								marginRight: 8,
								cursor: 'pointer'
							}}
							variant='contained'
						>
							<Box
								component={'img'}
								style={{
									height: 24,
									margin: 12,
									width: 24
								}}
								alt='eye'
								src={imageRight}
								onClick={handleRightButton}
								onMouseDown={handleMouseDown}
								onMouseUp={handleMouseUp}
								onMouseLeave={handleMouseLeave}
							/>
						</ButtonBase>
					) : (
						(error && (
							<Box
								component={'img'}
								style={{
									height: 24,
									marginRight: 12,
									width: 24,
									alignSelf: 'center'
								}}
								alt='eye'
								src={errorImage}
							/>
						))
						|| null
					)}
				</div>
			</Stack>
			{errorRecep && (
				<div
					className='medium8'
					style={{
						color: '#E96666',
						marginTop: '2px'
					}}
				>
					{errorRecep}
				</div>
			)}
		</div>
	);
};

TextField.propTypes = {
	text: PropTypes.any,
	textcolor: PropTypes.any,
	type: PropTypes.any,
	imageleft: PropTypes.any,
	imageRight: PropTypes.any,
	greentick: PropTypes.any,
	removeImageLeftBorder: PropTypes.any,
	borderColor: PropTypes.any,
	textLeft: PropTypes.any,
	handleRightButton: PropTypes.any,
	handleInput: PropTypes.any,
	name: PropTypes.any,
	error: PropTypes.any,
	value: PropTypes.any,
	placeholder: PropTypes.any,
	width: PropTypes.any,
	height: PropTypes.any,
	greentickWidth: PropTypes.any,
	className: PropTypes.any,
	required: PropTypes.any,
	handleClick: PropTypes.any,
	disabled: PropTypes.any,
	labelClassName: PropTypes.any,
	handleMouseDown: PropTypes.any,
	handleMouseUp: PropTypes.any,
	handleMouseLeave: PropTypes.any,
	textArea: PropTypes.any,
	maxLength: PropTypes.any,
	autoComplete: PropTypes.any,
	textAreaPadding: PropTypes.any,
	onCopy: PropTypes.any,
	onPaste: PropTypes.any,
	onBlur: PropTypes.any,
	onFocus: PropTypes.any,
	customStyle: PropTypes.any,
	marginTextBottom: PropTypes.any,
	textAreaHeight: PropTypes.any,
	errorRecep: PropTypes.any,
	marginTextTop: PropTypes.any,
	isColorChange: PropTypes.any,
	placeholderStyles: PropTypes.any,
	textMarginLeft: PropTypes.any,
	textMarginRight: PropTypes.any,
	newType: PropTypes.any,
	divStyles: PropTypes.any,
	maxDate: PropTypes.any,
	showBorder: PropTypes.any,
	leftBorder: PropTypes.any
};
